// top navigation bar

import { IconButton, Stack, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import NavbarMenu from './navbarMenu';
import { Routes } from 'src/utils/enums';
import SideBar from './sideBar';
import theme from 'src/theme/theme';
import { useNavigate } from 'react-router-dom';

const Navbar: React.FC = () => {
    const navigate = useNavigate();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
   

    return (
        <Stack alignItems="center" fontWeight={500} px={10} mt={6} direction="row" justifyContent="space-between" width="100%">
            <Typography
                fontSize={24}
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate(Routes.LANDING_PAGE)}
            >
                RealignHealthcare<span style={{ color: "#ea728c" }}>.</span>
            </Typography>
            {isSmallScreen ?
                <IconButton onClick={() => setIsDrawerOpen(true)}><MenuIcon sx={{ color: 'white' }} /></IconButton>
                : <NavbarMenu/>}
            <SideBar isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen}/>
        </Stack>
    );
};

export default Navbar;
